import { useCallback, useEffect, useState } from "react"
import PurchaseOrder from "./PurchaseOrder"
import { useDispatch, useSelector } from "react-redux";
import { getCreatePODetails, getsaveBulkOrderFleetPurchaseOrder, setBulkOrderAlert, setBulkOrderFleetHeader, setCreatePODetails, setSaveBulkFleetPurchaseOrder } from "Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction";
import userSelectors from "redux/UserProfile/selectors";
import FleetProcessingDispatch from "Store/OrderManagement/FleetProcessing/FleetProcessingDispatch";
import moment from "moment";
import SuccessBee from "../../../../assets/images/SuccessBee.svg";
import confirmationBee from "client/assets/images/ConfirmationBee.svg"
import { setFleetPo } from "Store/OrderManagement/FleetProcessing/FleetProcessingAction";
import { CONSTANTS } from "client/utils/constants";

const PurchaseOrderContainer = (props?: any) => {
  const dispatch = useDispatch();
  const dispatchGetFleetPo = FleetProcessingDispatch.dispatchGetFleetPo(dispatch);
  const purchaseOrderStepperData = props?.purchaseOrderStepperData;
  const setIsButtondisable = props?.setIsButtondisable;
  const [showCreatePoPopup, setShowCreatePOPopup] = useState(false);
  const [poErrors, setPOErrors] = useState<any>({});
  const [currentorderDetailId, setCurrentOrderdetailId] = useState<any>(0);
  const [showLoadingMessage, setshowLoadingMessage] = useState<any>(false);
  const [poNeedToCreate, setPONeedToCreate ] = useState<any>([]);
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });
  const [showAlert, setShowAlert] = useState({ show: false, type: "", text: "", source: ""});

  const { bulkOrderFleetDetails,
    createdBulkPODetails,
    userDetails,
    fleetPo,
    isBulkFleetPurchaseOrderSaved }: any = useSelector((state: any) => ({
      bulkOrderFleetDetails: state.PurchaseBulkOrderReducer.bulkOrderFleetDetails,
      createdBulkPODetails: state.PurchaseBulkOrderReducer.createdBulkPODetails,
      userDetails: userSelectors.getUserDetails(state),
      fleetPo: state.FleetProcessingReducer.fleetPo,
      isBulkFleetPurchaseOrderSaved: state.PurchaseBulkOrderReducer.isBulkFleetPurchaseOrderSaved,
    }))

  useEffect(() => {
    const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == currentorderDetailId);
    if (changedVendorDetails?.isPOCreated && !changedVendorDetails?.isPoPartiallyCreated && !changedVendorDetails?.isNonConsolidatedPOCreated) {
      setIsButtondisable(false)
    } else {
      setIsButtondisable(true)
    }
    dispatch(setCreatePODetails(null))
  }, [])

  useEffect(() => {
    if (bulkOrderFleetDetails) {
      bulkOrderFleetDetails?.map((fleetItem?: any) => {
        if (fleetItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId) {
          if (purchaseOrderStepperData?.isPOCreated && !purchaseOrderStepperData?.isPoPartiallyCreated && !purchaseOrderStepperData?.isNonConsolidatedPOCreated) {
            setIsButtondisable(false)
          } else {
            setIsButtondisable(true)
          }
        }
      })
    }
  }, [bulkOrderFleetDetails])

  const createLineItemarray = () => {
    let lineItemPayLoad: any = [];
    purchaseOrderStepperData?.purchaseDetails?.items?.map((purchasedetailItem?: any) => {
      if(!purchasedetailItem?.poNumber || purchasedetailItem?.poNumber == null || purchasedetailItem?.poNumber == undefined){
      let val = {
        desc1: purchaseOrderStepperData?.purchaseOrder?.poDescription1,
        desc2: purchaseOrderStepperData?.purchaseOrder?.poDescription2 ?? "",
        price: purchaseOrderStepperData?.pricePerUnit ? purchaseOrderStepperData?.pricePerUnit : 0,
        glAccount: purchaseOrderStepperData?.glCode ?? "",
        assetNumber: purchasedetailItem?.assetNumber?.toString() ?? "",
        isPrePaid: false,
        prepaidAmount: 0,
        modelID: purchaseOrderStepperData?.purchaseDetails?.assetModelId ?? 0,
        requestItemNo: purchasedetailItem?.itemId ? parseInt(purchasedetailItem?.itemId?.split('-')?.[1]) : 0,
        estDeliveryDate: moment(new Date()).format('YYYY-MM-DD')
      }
      lineItemPayLoad?.push(val)
      }
    })
    return (lineItemPayLoad)
  }

  const createPOClick = () => {
    setCurrentOrderdetailId(purchaseOrderStepperData?.orderDetailId)
    const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId);
    let isValidPODetails = hasValidPODetails(changedVendorDetails)
    if (isValidPODetails) {
      setCurrentOrderdetailId(purchaseOrderStepperData?.orderDetailId)
      let poNeedToCreate:any = []
      if (!purchaseOrderStepperData?.purchaseDetails?.createUniquePo) {
         purchaseOrderStepperData?.purchaseDetails?.items?.map((purchasedetailItem?: any) => {        
          if(![CONSTANTS.PO_STATUS.IN_PROGRESS, CONSTANTS.PO_STATUS.COMPLETE].includes(purchasedetailItem?.status)){
            poNeedToCreate.push(purchasedetailItem)          
          }       
        })
        setPONeedToCreate(poNeedToCreate)
        setShowCreatePOPopup(true)
      } else {
        setShowCreatePOPopup(false);
        let payloadTemp = {
          orderId: purchaseOrderStepperData?.purchaseDetails?.items[0]?.itemId ? parseInt(purchaseOrderStepperData?.purchaseDetails?.items[0]?.itemId?.split('-')?.[0]) : 0,
          itemNumber: purchaseOrderStepperData?.purchaseDetails?.items[0]?.itemId ? parseInt(purchaseOrderStepperData?.purchaseDetails?.items[0]?.itemId?.split('-')?.[1]) : 0,
          vendorNumber: purchaseOrderStepperData?.vendorDetails?.vendorAbNumber ?? 0,
          isConsolidatedPO: true,
          lineItems: createLineItemarray(),
          savedBy: userDetails.emailId
        }
        dispatchGetFleetPo(payloadTemp)
      }
    } else {
      setShowCreatePOPopup(false)
    }
  }

  useEffect(() => {
    let decriptionTxt: any
    if(createdBulkPODetails?.response && createdBulkPODetails != null && createdBulkPODetails?.id == purchaseOrderStepperData?.orderDetailId && !createdBulkPODetails?.response?.isValid){
      setShowAlert({ show: true, type: "warning", text: createdBulkPODetails?.response?.validationMessage, source: createdBulkPODetails?.response?.source})
      hideCreatePOPopup()
      setIsButtondisable(false)
      setshowLoadingMessage(false)
      setTimeout(() => {
        setShowAlert({ show: false, type: "", text: "", source: ""})
      }, 5000);
    } else if (createdBulkPODetails?.response && createdBulkPODetails != null && createdBulkPODetails?.id == purchaseOrderStepperData?.orderDetailId && createdBulkPODetails?.response?.isValid) {
      const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
      bulkOrderFleetDetailsTemp?.map((item?: any) => {
        if (item?.orderDetailId == purchaseOrderStepperData?.orderDetailId) {
          item.isPOCreated = true
          item.isPoPartiallyCreated = false
          item.isNonConsolidatedPOCreated = true
        }
      })
      dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp));
      hideCreatePOPopup()
      setIsButtondisable(true)
      setshowLoadingMessage(false)
      decriptionTxt = (
        <>
          <p>Please check back later for PO #s</p>
        </>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: SuccessBee,
        title: "PO CREATION SUBMITTED",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "OK",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
        }
      });
    } else if (!createdBulkPODetails?.response && createdBulkPODetails != null && createdBulkPODetails?.id == purchaseOrderStepperData?.orderDetailId) {
      setIsButtondisable(true)
      hideCreatePOPopup()
      setshowLoadingMessage(false)
      decriptionTxt = (
        <>
          <p>Error occured while creating the PO</p>
        </>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: confirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "OK",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
        }
      });
    }
    dispatch(setCreatePODetails(null))
  }, [createdBulkPODetails])

  useEffect(() => {
    if (fleetPo?.errorMessages?.length == 0 && fleetPo != null) {
      const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
      bulkOrderFleetDetailsTemp?.map((item?: any) => {
        if (item?.orderDetailId == purchaseOrderStepperData?.orderDetailId) {
          item?.purchaseDetails?.items?.map((itemVal?: any) => {
            itemVal.poNumber = fleetPo?.poNumber
            itemVal.poCreationDate = fleetPo?.poCreatedDate
          })
          item.purchaseOrder.poNumber = fleetPo?.poNumber
          item.purchaseOrder.poCreationDate = fleetPo?.poCreatedDate
          item.isPOCreated = true
          item.isPoPartiallyCreated = false
        }
      })
      dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp));
    } else if((fleetPo?.errorMessages?.length && fleetPo != null)) {
      if (currentorderDetailId == purchaseOrderStepperData?.orderDetailId) {
        let totalError = fleetPo?.errorMessages?.join(',');
        dispatch(setBulkOrderAlert({
          showAlert: true,
          type: "warning",
          text: totalError,
          orderDetailId: currentorderDetailId,
        }))
      }
    }
    dispatch(setFleetPo(null))
  }, [fleetPo])

  const createPOOnConfirmation = () => {
    if (!purchaseOrderStepperData?.purchaseDetails?.createUniquePo) {
      let payload: any = [];
      let payloadTemp: any = {};
      let orderDetailId: any = purchaseOrderStepperData?.orderDetailId
      purchaseOrderStepperData?.purchaseDetails?.items?.map((purchasedetailItem?: any) => {
        if(![CONSTANTS.PO_STATUS.IN_PROGRESS, CONSTANTS.PO_STATUS.COMPLETE].includes(purchasedetailItem?.status)){
        payloadTemp = {
          orderId: purchasedetailItem?.itemId ? parseInt(purchasedetailItem?.itemId?.split('-')?.[0]) : 0,
          itemNumber: purchasedetailItem?.itemId ? parseInt(purchasedetailItem?.itemId?.split('-')?.[1]) : 0,
          vendorNumber: purchaseOrderStepperData?.vendorDetails?.vendorAbNumber ?? 0,
          isConsolidatedPO: false,
          poRetryTrue: purchaseOrderStepperData?.isPoPartiallyCreated,
          lineItems: [
            {
              desc1: purchaseOrderStepperData?.purchaseOrder?.poDescription1,
              desc2: purchaseOrderStepperData?.purchaseOrder?.poDescription2 ?? "",
              price: purchaseOrderStepperData?.pricePerUnit ? purchaseOrderStepperData?.pricePerUnit : 0,
              glAccount: purchaseOrderStepperData?.glCode ?? "",
              assetNumber: purchasedetailItem?.assetNumber?.toString() ?? "",
              isPrePaid: false,
              prepaidAmount: 0,
              modelID: purchaseOrderStepperData?.purchaseDetails?.assetModelId ?? 0,
              requestItemNo: purchasedetailItem?.itemId ? parseInt(purchasedetailItem?.itemId?.split('-')?.[1]) : 0,
              estDeliveryDate: moment(new Date()).format('YYYY-MM-DD')
            }
          ],
          savedBy: userDetails.emailId
        }
        payload.push(payloadTemp)
        }       
      })
      dispatch(getCreatePODetails(payload,orderDetailId))
      setshowLoadingMessage(true)
    }
  }

  const hideCreatePOPopup = () => {
    setShowCreatePOPopup(false)
  }

  const hasValidPODetails = (changedVendorDetails?: any) => {
    setPOErrors({
      poDescription1: !changedVendorDetails?.purchaseOrder?.poDescription1 || changedVendorDetails?.purchaseOrder?.poDescription1?.length > 30,
      poDescription2: (changedVendorDetails?.purchaseOrder?.poDescription2 ? changedVendorDetails?.purchaseOrder?.poDescription2?.length > 30 : false),
      make: (changedVendorDetails?.purchaseOrder?.make ? changedVendorDetails?.purchaseOrder?.make?.length > 50 : false),
      model: (changedVendorDetails?.purchaseOrder?.model ? changedVendorDetails?.purchaseOrder?.model?.length > 50 : false)
    });
    return (
      changedVendorDetails?.purchaseOrder?.poDescription1 &&
      changedVendorDetails?.purchaseOrder?.poDescription1?.length <= 30 &&
      (changedVendorDetails?.purchaseOrder?.poDescription2 ? changedVendorDetails?.purchaseOrder?.poDescription2?.length <= 30 : true) &&
      (changedVendorDetails?.purchaseOrder?.make ? changedVendorDetails?.purchaseOrder?.make?.length <= 50 : true) &&
      (changedVendorDetails?.purchaseOrder?.model ? changedVendorDetails?.purchaseOrder?.model?.length <= 50 : true)
    );
  };

  const handleChange = (event: any, items?: any) => {
    const value = event.target.value;
    const name = event.target.name;
    if (name == "poDescription1" || name == "poDescription2" || name == "make" || name == "model") {
      const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
      bulkOrderFleetDetailsTemp?.map((item?: any) => {
        if (item?.orderDetailId == purchaseOrderStepperData?.orderDetailId) {
          item.purchaseOrder = {
            ...item?.purchaseOrder,
            [name]: value
          }
        }
      })
      dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp));
      let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId);
      hasValidPODetails(changedVendorDetails)
    };

  }
  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  };

  const createPODetailsPayload = (changedVendorDetails?: any) => {
    let payload = {
      orderDetailId: parseInt(changedVendorDetails?.orderDetailId),
      poDescription1: (changedVendorDetails.purchaseOrder.poDescription1 && changedVendorDetails?.purchaseOrder?.poDescription1?.length <= 30) ? changedVendorDetails?.purchaseOrder?.poDescription1 : "",
      poDescription2: (changedVendorDetails?.purchaseOrder?.poDescription2 && changedVendorDetails?.purchaseOrder?.poDescription2?.length <= 30) ? changedVendorDetails?.purchaseOrder?.poDescription2 : '',
      make: (changedVendorDetails?.purchaseOrder?.make && changedVendorDetails?.purchaseOrder?.make?.length <= 50) ? changedVendorDetails?.purchaseOrder?.make : '',
      model: (changedVendorDetails?.purchaseOrder?.model && changedVendorDetails?.purchaseOrder?.model?.length <= 50) ? changedVendorDetails?.purchaseOrder?.model : '',
      savedBy: userDetails?.emailId
    }
    dispatch(getsaveBulkOrderFleetPurchaseOrder(payload))
  }

  const desc1OnBlur = () => {
    const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId);
    if (changedVendorDetails.purchaseOrder.poDescription1 &&
      changedVendorDetails?.purchaseOrder?.poDescription1?.length <= 30) {
      createPODetailsPayload(changedVendorDetails)
    }
  }

  const desc2OnBlur = () => {
    const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId);
    if (changedVendorDetails.purchaseOrder.poDescription2 ? changedVendorDetails?.purchaseOrder?.poDescription2?.length <= 30 : true) {
      createPODetailsPayload(changedVendorDetails)
    }
  }

  const makeOnBlur = () => {
    const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId);
    if (changedVendorDetails?.purchaseOrder?.make ? changedVendorDetails?.purchaseOrder?.make?.length <= 50 : true) {
      createPODetailsPayload(changedVendorDetails)
    }
  }

  const modelOnBlur = () => {
    const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId);
    if (changedVendorDetails?.purchaseOrder?.model ? changedVendorDetails?.purchaseOrder?.model?.length <= 50 : true) {
      createPODetailsPayload(changedVendorDetails)
    }
  }

  const getPONumber = useCallback((type?: any) => {
    if (type == "poNumber") {
      return purchaseOrderStepperData?.poNumber
    } else if (type == "poCreationDate") {
      return purchaseOrderStepperData?.poCreationDate
    }
  }, [purchaseOrderStepperData?.poNumber])

  useEffect(() => {
    if (!isBulkFleetPurchaseOrderSaved?.isSaved && isBulkFleetPurchaseOrderSaved != null) {
      let decriptionTxt = (
        <>
          <p>Error Occured while saving the value.</p>
        </>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: confirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "OK",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclick: () => {
          setPopupcontent({ ...Popupcontent, isDialogVisible: false })
        }
      });
    }
    dispatch(setSaveBulkFleetPurchaseOrder(null))
  }, [isBulkFleetPurchaseOrderSaved])

  const dismissAlert = () => {
    setShowAlert({ show: false, type: "", text: "", source: ""})
  }

  return (
    <PurchaseOrder
      createPOClick={createPOClick}
      hideCreatePOPopup={hideCreatePOPopup}
      showCreatePoPopup={showCreatePoPopup}
      handleChange={handleChange}
      poErrors={poErrors}
      purchaseOrderStepperData={purchaseOrderStepperData}
      createPOOnConfirmation={createPOOnConfirmation}
      setIsButtondisable={setIsButtondisable}
      showLoadingMessage={showLoadingMessage}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      desc1OnBlur={desc1OnBlur}
      desc2OnBlur={desc2OnBlur}
      makeOnBlur={makeOnBlur}
      modelOnBlur={modelOnBlur}
      poNeedToCreate = {poNeedToCreate}
      getPONumber = {getPONumber}
      showAlert={showAlert}
      dismissAlert={dismissAlert}
    />
  )
}

export default PurchaseOrderContainer